const Config = {
//  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://localhost:7190',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://eshterak-api.mouood.com',
};

export default Config;
